(function () {
  if (customElements.get('product-recommendations')) return;

  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      connectedCallback() {
        var url = this.dataset.url;
        if (!url || this.dataset.loaded === 'true') return;

        fetch(url)
          .then(function (r) {
            return r.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('product-recommendations');
            if (fresh && fresh.innerHTML.trim().length) {
              this.innerHTML = fresh.innerHTML;
              this.dataset.loaded = 'true';
              document.dispatchEvent(new CustomEvent('recommendations:loaded'));
            }
          }.bind(this))
          .catch(function () {});
      }
    }
  );
})();
